import { Logo } from '@images';
import { StyledTitle } from '@styles/app.styles';
import { __ } from '@utils/i18n';

const AppTitle = () => {
	return (
		<>
			<Logo />

			<StyledTitle variant="subtitle1" as="h2">
				{__('Ally Accessibility')}
			</StyledTitle>
		</>
	);
};

export default AppTitle;
